import {
  EntityList,
  EntityListProps,
  renderDate,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving, User } from 'gql.generated'
import { Box } from 'grid'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

export type ArchiveNrListProps = EntityListProps<ReadProvings_workers>

export const ArchiveNrList: React.FunctionComponent<ArchiveNrListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('status', {
        onRender: renderStatusIcon,
        ungroupable: true,
      }),
      fieldColumn('id', { ungroupable: true, isSortedDescending: false }),

      fieldColumn('title', {
        ungroupable: true,
        minWidth: 320,
      }),
      fieldColumn('dateFrom', {
        onRender: renderDate,

        ungroupable: true,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
        ungroupable: true,
      }),

      fieldColumn('responsible', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.responsible.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    {user.name}
                  </Box>
                )
              })}
            </div>
          )
        },
        getGroupValue: (item: Proving) => {
          let result = ''
          if (item.responsible) {
            item.responsible.forEach((user: User) => {
              result = `${result} ${user.name}`
            })
          }
          return result
        },
        ungroupable: true,
        minWidth: 105,
      }),
      fieldColumn('department', { ungroupable: true }),
    ],
    [fieldColumn]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
